//! DO NOT EDIT THIS FILE IT IS GENERATED USING:
// mgs generate-flags

// Description: A feature flag to set the number of products shown in the product selection for doctors when adding medication
// Default On Variation: 5
// Default Off Variation: 3
export const FF_PRESCRIPTION_RECOMMENDED_PRODUCTS_COUNT = 'prescription_recommended_products_count';

// Description: It allows you to display or hide the promo code discount line in the payment step. (Appointment Summary)
// Default On Variation: true
// Default Off Variation: false
export const FF_DISPLAY_PROMO_CODE_DISCOUNT = 'display_promo_code_discount';

// Default On Variation: {"repeats":2,"state":true}
// Default Off Variation: {"state":false}
export const FF_INVENTORY_INSIGHTS_ENFORCE_GREENA_REPEATS = 'inventory_insights_enforce_greena_repeats';

// Description: https://montugroup.atlassian.net/browse/B2CS-98 https://montugroup.atlassian.net/browse/B2CS-238
// Default On Variation: true
// Default Off Variation: false
export const FF_USE_SHOPIFY_PRODUCT_IMAGES = 'use_shopify_product_images';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE = 'enable_google_places_autocomplete';

// Description: Enables Snowplow Tracking
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SNOWPLOW = 'enable_snowplow';

// Description: toggle visibility of Consultation Notes History within a single consultation
// Default On Variation: true
// Default Off Variation: false
export const FF_VIEW_CONSULTATION_NOTES_HISTORY = 'view_consultation_notes_history';

// Description: Enable devices to be prescribed via the Prescription Assistant Tool (PAT). When ON, the "Add Device" button is visible to the user.
// When OFF, the button is hidden to prevent devices being added to prescriptions.
// Default On Variation: true
// Default Off Variation: false
export const FF_PAT_ENABLE_DEVICE_PRESCRIPTION = 'pat_enable_device_prescription';

// Description: (Connect for Clinic) Hides patient phone number for doctors in PMS
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_HIDE_PATIENT_PHONE_NUMBER = 'c4c_hide_patient_phone_number';

// Description: Enable Amazon connect video consult for specific user segments
// Default On Variation: true
// Default Off Variation: false
export const FF_C4C_ENABLE_CONNECT_VIDEO_CONSULT = 'c4c_enable_connect_video_consult';

// Description: Debug logic that cannot be validated locally
// Default On Variation: true
// Default Off Variation: false
export const FF_WOMBATS_DEVICE_TESTING = 'wombats_device_testing';

// Description: Feature flag to toggle the patient centric followups ON and OFF
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_CENTRIC_FOLLOWUPS = 'patient_centric_followups';

// Description: Enabling spot doctor consultation in PMS.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SPOT_DOC_CONSULT = 'enable_spot_doc_consult';

// Description: https://montugroup.atlassian.net/wiki/spaces/Eng/pages/957743166/SPIKE+Variable+Consult+Types+Calcom+Decouple
// Default On Variation: true
// Default Off Variation: false
export const FF_VARIABLE_CONSULT_TYPES_ENABLED = 'variable_consult_types_enabled';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ALF_IN_PATIENT_PORTAL = 'enable-alf-in-patient-portal';

// Description: Close calcom iFrames on successful bookings to prevent navigation rebooking issues
// Default On Variation: true
// Default Off Variation: false
export const FF_CLOSE_CALCOM_IFRAME_ON_SUCCESS = 'close_calcom_iframe_on_success';

// Description: https://montugroup.atlassian.net/browse/LGA-321
// Default On Variation: true
// Default Off Variation: false
export const FF_DOCTORS_ROUND_ROBIN_FOR_UNDER_25 = 'doctors_round_robin_for_under_25';

// Description: Enables the free rescript eligibility chips on a patient's profile for PTX and nurses. When ON these chips are visible, and hidden
// when the flag is OFF
// Default On Variation: true
// Default Off Variation: false
export const FF_FREE_RESCRIPT_ELIGIBILITY = 'free_rescript_eligibility';

// Description: Enable doctor property features
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DOCTOR_PROPERTIES = 'enable-doctor-properties';

// Description: https://montugroup.atlassian.net/browse/LGA-484
// Default On Variation: true
// Default Off Variation: false
export const FF_REMOVE_SIGNATURE_BOX_FROM_CONSENT_FORM = 'remove_signature_box_from_consent_form';

// Description: Normalises and sanitises non-standard characters in prescription dosage text. Prevents progressing to Review Script step if
// unsupported characters (e.g. the Unicode replacement character �) remain after sanitisation.`
// Default On Variation: true
// Default Off Variation: false
export const FF_SANITIZE_DOSAGE_TEXT_CHARACTERS = 'sanitize-dosage-text-characters';

// Description: https://montugroup.atlassian.net/browse/LGA-644
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_IDC_FOR_SCHEDULED_NURSE = 'enable_idc_for_scheduled_nurse';

// Description: https://montugroup.atlassian.net/browse/LGA-700
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_IDC_TRIGGER_SOURCE = 'enable-idc-trigger-source';

// Description: https://montugroup.atlassian.net/browse/LGA-716
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_ENABLE_OPEN_DOCUMENT_TAB_2026Q1 = 'patient_enable_open-document-tab_2026q1';

// Description: Enable validating Latin 1 safe fields in that impact erx conversion
// Default On Variation: true
// Default Off Variation: false
export const FF_VALIDATE_LATIN_SAFE = 'validate_latin_safe';

// Default On Variation: true
// Default Off Variation: false
export const FF_ERX_PRESCRIBER_CONFORMANCE_TESTING_PHASE = 'erx_prescriber_conformance_testing_phase';

// Description: Displays consultation outcome instead of actions for doctors conducting a consultation
// Default On Variation: true
// Default Off Variation: false
export const FF_DOC_CONSULT_OUTCOME = 'doc_consult_outcome';

// Description: enable calcom management tools in PMS
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CALCOM_MANAGEMENT_TOOLS = 'enable_calcom_management_tools';

// Description: test only passing status_id to update consultation endpoint if it has been changed.
// Default On Variation: true
// Default Off Variation: false
export const FF_REMOVE_UNCHANGED_CONSULT_STATUS_FROM_UPDATE = 'remove_unchanged_consult_status_from_update';

// Description: give doctor the ability to book a patient's first followup button.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DOCTORS_OWN_FOLLOWUP_BUTTON = 'enable_doctors_own_followup_button';

// Description: Master flag enabling WA nurse consult booking restrictions. When on: "Book Any Doctor" routes to WA round robin; "Book Specific
// Doctor" filters to WA doctors + allowed IDs.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_WA_NURSE_CONSULT_RESTRICTION = 'enable_wa_nurse_consult_restriction';

// Description: Array of additional doctor codes permitted for WA patients in "Book Specific Doctor" list, regardless of doctor state.
// Default On Variation: ["ALDID000002"]
// Default Off Variation: ["ALDID000002"]
export const FF_WA_ALLOWED_DOCTOR_CODES = 'wa_allowed_doctor_codes';

// Description: Enables an experiment to add a pricing filter to our prescription assistant tool, and to show prices on products
// Default On Variation: true
// Default Off Variation: false
export const FF_PRESCRIPTIONS_EXPERIMENT_PAT_PRICING_FILTER = 'prescriptions_experiment_pat_pricing_filter';

// Description: When reissuing an out of stock / discontinued / inactive / unavailable product in the prescription assistant tool,
// pre-select the first available alternative instead of leaving the out of service product selected
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLED_OOS_REISSUE_AUTO_ALTERNATIVE = 'enabled_oos_reissue_auto_alternative';

// Description: Use sub-statuses from the API instead of the hardcoded constants
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CONSULTATION_SUBSTATUSES_FROM_API = 'enable_consultation_substatuses_from_api';

// Description: Informs the clinician the patient is from WA
// Default On Variation: true
// Default Off Variation: false
export const FF_WA_PATIENT_ALERT = 'wa-patient-alert';

// Description: Set the createdBy field on the calcom button when booking consultations
// Default On Variation: true
// Default Off Variation: false
export const FF_CALCOM_SET_CREATEDBY = 'calcom_set_createdby';

// Description: !! All doctors must have SSO setup. Before a prescriber submits a prescription, the prescriber is prompted with a re-authentication.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PRESCRIBE_REAUTH = 'enable_prescribe_reauth';

// Description: Trialing the existing ringtone at a lower volume for video consults, as well as an alternative option
// Default On Variation:
// Default Off Variation:
export const FF_CONSULTATIONS_EXPERIMENT_RINGTONE = 'consultations_experiment_ringtone';

// Description: Allows doctors to request a task based on a consultation outcome
// Default On Variation: true
// Default Off Variation: false
export const FF_DOC_CONSULT_TASKS = 'doc_consult_tasks';

// Description: Create prescriptions through the X-API pms/v1 prescribe endpoint instead of the legacy pms-service one
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CREATE_PRESCRIPTION_V2_ENDPOINT = 'enable_create_prescription_v2_endpoint';

// Description: Enables prescription dispense limits on the prescription pad (Herb, Dried pad items only)
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PRESCRIPTION_DISPENSE_LIMITS = 'enable_prescription_dispense_limits';

// Description: Requires the maximum daily dose on Herb, Dried prescription pad items while dispense limits are on
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PRESCRIPTION_MANDATORY_MAXIMUM_DAILY_DOSAGES =
  'enable_prescription_mandatory_maximum_daily_dosages';
